/**
 * Content addressing for label-raster run blobs.
 *
 * Checkpoints in the session CBOR reference each chunk's runs by key; the
 * bytes are stored once at the session level (`labelRasterRunStore`). Two
 * independent 32-bit hashes plus the byte length make accidental collisions
 * negligible for this use (undo history of one submission).
 */

let crcTable: Uint32Array | null = null

function crc32(bytes: Uint8Array): number {
  if (!crcTable) {
    crcTable = new Uint32Array(256)
    for (let n = 0; n < 256; n++) {
      let c = n
      for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1
      crcTable[n] = c >>> 0
    }
  }
  let crc = 0xffffffff
  for (let i = 0; i < bytes.length; i++) {
    crc = (crcTable[(crc ^ (bytes[i] as number)) & 0xff] as number) ^ (crc >>> 8)
  }
  return (crc ^ 0xffffffff) >>> 0
}

function fnv1a32(bytes: Uint8Array): number {
  let h = 0x811c9dc5
  for (let i = 0; i < bytes.length; i++) {
    h ^= bytes[i] as number
    h = Math.imul(h, 0x01000193) >>> 0
  }
  return h >>> 0
}

/** Stable key for a run blob: `<length>-<crc32>-<fnv1a>` (hex hashes). */
export function labelRasterRunKey(runs: Uint8Array): string {
  return `${runs.byteLength}-${crc32(runs).toString(16)}-${fnv1a32(runs).toString(16)}`
}
